import React, { Component } from 'react'
import { ReactComponent as Telegram } from '../../assets/svgs/telegram.svg'
import { ReactComponent as Skype } from '../../assets/svgs/skype.svg'
import { ReactComponent as Whatsapp } from '../../assets/svgs/whatsapp.svg'
import { ReactComponent as Instagram } from '../../assets/svgs/instagram.svg'
import { ReactComponent as Phone } from '../../assets/svgs/phone.svg'
import { ReactComponent as Facebook } from '../../assets/svgs/facevook.svg'
import { ReactComponent as Email } from '../../assets/svgs/email.svg'

import styles from '../../containers/CounselingCenter/components/ConsultantCard/ConsultantCard.module.scss'

class SocialNetworks extends Component {
	SOCIAL_NETWORKS = {
		telegram: <Telegram with={20} height={18} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>,
		skype: <Skype with={20} height={18} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>,
		whatsapp: <Whatsapp with={20} height={18} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>,
		call: <Phone with={20} height={18} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>,
		instagram: <Instagram with={20} height={18}  style={{ marginLeft: 8 }}/>,
		facebook: <Facebook with={20} height={18} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>,
		email: <Email with={20} height={18} fill={'#CACDD9'} style={{ marginLeft: 8 }}/>
	}

	render() {
		return (
			<div className={styles.Icons}>
				{
					this.props.socialNetworks.map((socialNetwork, index) => {
						let socialAddress = ''
						if (typeof socialNetwork === 'object') {
							socialAddress = socialNetwork.address
							socialNetwork = socialNetwork.social_network
						}

						if(socialAddress)
						return (
							<a key={index} href={socialAddress}>
								{this.SOCIAL_NETWORKS[socialNetwork]}
							</a>
						)

						return (
							<span key={index}>
								{this.SOCIAL_NETWORKS[socialNetwork]}
							</span>
						)
					})
				}
			</div>
		)
	}
}

export default SocialNetworks
